import { Button, Css } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { useDownloadBidSheetV2 } from "src/routes/bids/components/DownloadBidSheetV2Modal";
import { fail, queryResult } from "src/utils";
import { PlanBasedBidPackageFormState, PlanBasedBidPackageWizard } from "../utils";
import { usePlanBasedBidPackageReviewAndDownloadStepQuery } from "./3.ReviewAndDownloadStep.generated";
import { PlanBasedBidsTableV2 } from "./PlanBasedBidsTableV2";

type ReviewAndDownloadStepProps = {
  formState: ObjectState<PlanBasedBidPackageFormState>;
  wizard?: PlanBasedBidPackageWizard;
};

export function ReviewAndDownloadStep(props: ReviewAndDownloadStepProps) {
  const { formState, wizard } = props;
  const query = usePlanBasedBidPackageReviewAndDownloadStepQuery({
    variables: { bidPackageId: formState.bidPackageId.value ?? fail("bidPackageId is required") },
  });
  const downloadBidSheetV2 = useDownloadBidSheetV2();
  return (
    <div css={Css.df.fdc.mb8.$}>
      <div css={Css.df.fdc.aic.mt6.mb2.$}>
        <div css={Css.xl2.mb2.$}>Review Bid</div>
        <div css={Css.mb1.tac.$}>
          Preview the cost lines below. Return to Step 2 to make changes before creating. After creating, you can edit
          <br />
          the bid or download the bid sheet anytime.
        </div>
      </div>
      {queryResult(query, ({ bidPackage }) => (
        <>
          <div css={Css.mla.mb1.$}>
            <Button
              icon="download"
              label="Download Bidsheet"
              onClick={() => downloadBidSheetV2(bidPackage)}
              variant="secondaryBlack"
              size="md"
            />
          </div>
          <PlanBasedBidsTableV2 bidPackage={bidPackage} wizard={wizard} />
        </>
      ))}
    </div>
  );
}
